import { render } from "./StudentPreview.vue?vue&type=template&id=531a08ea&scoped=true"
import script from "./StudentPreview.vue?vue&type=script&lang=js"
export * from "./StudentPreview.vue?vue&type=script&lang=js"

import "./StudentPreview.vue?vue&type=style&index=0&id=531a08ea&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531a08ea"]])

export default __exports__